var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"notification-bell",on:{"click":_vm.toggleFollow}},[_c('img',{attrs:{"src":'../../images/icons/' + _vm.bell_icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }